module.exports = __webpack_public_path__ + "static/img/clock.f7c058ca.png";